export enum PaymentRequestChannelType {
  SHOP_AND_FLY_WEB = 'ShopAndFlyWeb',
  SHOP_AND_FLY_CALL_CENTER = 'ShopAndFlyCallCenter',
  SHOP_AND_FLY_CALL_CENTER_MANUAL_PAYMENT = 'ShopAndFlyCallCenterManualPayment',
}
